import { Fragment } from 'react';
import { BEAKER_CLASSES } from '../constants/classNames';
import { MAX_SELECTED_SUBSTANCES } from '../constants/config';
import { joinClassNames } from '../utils/classNameUtils';
import '../styles/MixingBench.css';

function BenchSlot({ substance, onRemove }) {
  if (!substance) {
    return <div className={joinClassNames(BEAKER_CLASSES.slot, BEAKER_CLASSES.slotEmpty)}>?</div>;
  }
  return (
    <div className={BEAKER_CLASSES.slot}>
      <strong>{substance.symbol}</strong>
      <span>{substance.name}</span>
      <button
        type="button"
        className={BEAKER_CLASSES.slotRemove}
        aria-label={`Remove ${substance.name}`}
        onClick={() => onRemove(substance.id)}
      >
        ✕
      </button>
    </div>
  );
}

export default function MixingBench({ selectedSubstances, canMix, isMixing, onMix, onReset, onRemoveSubstance }) {
  const slots = Array.from({ length: MAX_SELECTED_SUBSTANCES }, (_, index) => selectedSubstances[index] ?? null);

  return (
    <div className={BEAKER_CLASSES.root}>
      <div className={BEAKER_CLASSES.slots}>
        {slots.map((substance, index) => (
          <Fragment key={substance?.id ?? `empty-${index}`}>
            {index > 0 && <span className={BEAKER_CLASSES.plus} aria-hidden="true">+</span>}
            <BenchSlot substance={substance} onRemove={onRemoveSubstance} />
          </Fragment>
        ))}
      </div>

      <div className={BEAKER_CLASSES.actions}>
        <button type="button" className={BEAKER_CLASSES.mixButton} disabled={!canMix} onClick={onMix}>
          {isMixing ? 'Mixing...' : 'Mix! 🧪'}
        </button>
        <button type="button" className={BEAKER_CLASSES.resetButton} onClick={onReset}>
          Clear
        </button>
      </div>

      {!canMix && !isMixing && (
        <p className={BEAKER_CLASSES.hint}>Choose {MAX_SELECTED_SUBSTANCES} elements from the periodic table to start mixing.</p>
      )}
    </div>
  );
}
